import React, { useState, useEffect } from "react";
import { ShortDescriptionAPI } from "@api";
import styled from "styled-components";
import {
  Calendar,
  ContainerFrame,
  FooterSection,
  LeadingTitle,
} from "@components";
import { useTranslation } from "react-i18next";

const CorporateContainer = styled.div`
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px){
    padding-top: 0;
  }
`;

const Agenda = function () {
  const {t} = useTranslation();
  const [shortDesc, setShortDesc] = useState(null);
  useEffect(() => {
    const loadData = async () => {
      const { data } = await ShortDescriptionAPI({ loc: "kalender_acara" });
      setShortDesc(data.data);
    };

    if (!shortDesc) {
      loadData();
    }
  }, [shortDesc]);
  return (
    <CorporateContainer>
      <LeadingTitle
        title={t("kalender_acara")}
        subtitle={shortDesc !== null ? shortDesc[0].description : ""}
      />
      <ContainerFrame className="text-start py-5">
        <Calendar />
      </ContainerFrame>

      <FooterSection currentPage={t("kalender_acara")}/>
    </CorporateContainer>
  );
};

export default Agenda;
